// tslint:disable
/**
 * Ux
 * insightux admin api
 *
 * The version of the OpenAPI document: 0.62
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function PrivateBenchmarkPerformanceDataFromJSON(json) {
    return {
        'bottomFivePercent': !exists(json, 'bottomFivePercent') ? undefined : json['bottomFivePercent'],
        'lowerQuartile': !exists(json, 'lowerQuartile') ? undefined : json['lowerQuartile'],
        'median': !exists(json, 'median') ? undefined : json['median'],
        'topFivePercent': !exists(json, 'topFivePercent') ? undefined : json['topFivePercent'],
        'upperQuartile': !exists(json, 'upperQuartile') ? undefined : json['upperQuartile'],
        'pooledMean': !exists(json, 'pooledMean') ? undefined : json['pooledMean'],
    };
}
export function PrivateBenchmarkPerformanceDataToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    return {
        'bottomFivePercent': value.bottomFivePercent,
        'lowerQuartile': value.lowerQuartile,
        'median': value.median,
        'topFivePercent': value.topFivePercent,
        'upperQuartile': value.upperQuartile,
        'pooledMean': value.pooledMean,
    };
}
